import Dexie from 'dexie'

export const db = new Dexie('ygiadb');

db.version(1).stores({
    conversations : "&Referencia, id, MensajesSinVer, fecha, Channel, created_at, updated_at, Visto, Status, IdUsuario2, IdUsuario, TipoMensaje, message, Usuario, IdContacto, IdPaciente, Imagen_Url, TipoUsuario, status_chat, lastSync",
    mensajes: "id, IdUsuario, message, NombreMultimedia, Multimedia, MultimediaUrl, TipoMensaje, IdUsuario2, fecha, Referencia, Channel, Visto, Status, created_at, updated_at, Emisor, Usuario, IdPaciente, Imagen_Url",
})